import { IResult } from '../types/IResponse';
import { IUser } from '../types/IUser';
import { IResultCodes, IUserActionError } from '../types/IUserActionResult';
import { Request } from './Request';

export interface IImportSiteUsersFromActiveDirectoryParams {
  usernames: string[];
  siteRole?: string;
  admin?: boolean;
}

export interface IImportServerUsersFromActiveDirectoryParams {
  usernames: string[];
}

export interface IImportUsersFromActiveDirectoryResult extends IResult {
  results?: IResultCodes[];
  users: IUser[];
  errors?: IUserActionError[];
}

export class ImportSiteUsersFromActiveDirectoryRequest extends Request<IImportSiteUsersFromActiveDirectoryParams, IImportUsersFromActiveDirectoryResult> {
  constructor(params: IImportSiteUsersFromActiveDirectoryParams) {
    super('importUsersFromActiveDirectory', params);
  }
}

export class ImportServerUsersFromActiveDirectoryRequest extends Request<IImportServerUsersFromActiveDirectoryParams, IImportUsersFromActiveDirectoryResult> {
  constructor(params: IImportServerUsersFromActiveDirectoryParams) {
    super('importServerUsersFromActiveDirectory', params);
  }
}
